import { Component } from '@angular/core';

@Component({
    selector: 'app-nav-left',
    templateUrl: './nav-left.component.html',
    styleUrls: ['./nav-left.component.scss'],
    standalone: false
})
export class NavLeftComponent {}
